import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * Interfaz que implementa el componente que necesita controlar la salida.
 * El guard llama a `canDeactivate()` y espera la respuesta del usuario.
 */
export interface PuedeDesactivar {
    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

/**
 * Guard funcional CanDeactivate para el módulo de Activaciones Prepago.
 * Delega la lógica de confirmación al propio componente,
 * que mostrará el modal de abandono y resolverá la promesa según la respuesta del usuario.
 */
export const activacionDeactivateGuard: CanDeactivateFn<PuedeDesactivar> =
    (component: PuedeDesactivar): Observable<boolean> | Promise<boolean> | boolean => {
        return component.canDeactivate ? component.canDeactivate() : true;
    };
